import { render, staticRenderFns } from "./diagram_performance_warning.vue.js?vue&type=template&id=492a0064&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=template&id=492a0064&vue3"
import script from "./diagram_performance_warning.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=script&lang=js&vue3"
export * from "./diagram_performance_warning.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diagram_performance_warning.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports